const getFacilityName = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Info'] && facility['Company Info']['Company Name']) {
    return facility['Company Info']['Company Name'];
  }
  return null;
};

export default getFacilityName;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityName.js